// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 844) return "static/chunks/ee560e2c-4dc4299510ff0006.js";
	if (chunkId === 1875) return "static/chunks/1875-897027277c0bda18.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3884":"34339865f3d1df21","8298":"769dd8e933ba19b0"}[chunkId] + ".js";
};